// extracted by mini-css-extract-plugin
export default {"controlsContainer":"Controls_controlsContainer__Y6K1x","icon":"Controls_icon__etGKG"};